var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#fff;}")),React.createElement("path",{"className":"a","d":"M531.6,151.009v-7.528l-8.257-.081c-3.481,0-8.5,3.966-8.5,8.459v8.095H507.6v8.581h7.123v21.249h8.419v-21.37h7.447l.931-8.378h-8.257v-6.152a2.833,2.833,0,0,1,2.793-2.914Z","transform":"translate(-507.6 -143.4)","key":1})]);
}

FacebookIcon.defaultProps = {"width":"24.001","height":"46.384","viewBox":"0 0 24.001 46.384"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
